import { render } from "./EditPostView.vue?vue&type=template&id=78f3da92"
import script from "./EditPostView.vue?vue&type=script&lang=js"
export * from "./EditPostView.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\vue-workspace\\fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__